import React from "react";
import Modals from "../popupModal/modal";

const NoteModal = ({ onLock, onSaveAsTemplate, isOpen, closeModal }) => {
  return (
    <>
      <Modals
        isOpen={isOpen}
        onRequestClose={() => closeModal}
        title="Save Notes"
        styles={{
          content: {
            minWidth: "400px",
            maxWidth: "400px",
            minHeight: "280px",
            maxHeight: "280px",
          },
        }}
        btnDark={{
          label: "Save",
          onclick: () => {
            onLock();
            closeModal();
          },
        }}
        btnOutline={{
          label: "Save as Note & Template",
          onclick: () => {
            onSaveAsTemplate();
            closeModal();
          },
        }}
      >
        <>
          <div className="d-flex justify-content-center my-4">
        <button
          onClick={closeModal}
          className="close modalCloseBtn"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        </div>
        </>
      </Modals>
    </>
  );
};

export default NoteModal;
